type TwoFAInputKeys = 'twoFA';

export const TWO_FA_INPUT_KEYS: { [key in TwoFAInputKeys]: TwoFAInputKeys } = {
  twoFA: 'twoFA',
};

export type TwoFAFormInput = {
  twoFA: boolean;
};
